// extracted by mini-css-extract-plugin
module.exports = {"cardGroup":"_9615421"};